<template>
  <v-dialog scrollable persistent v-model="dialogShow" max-width="900px">
    <template v-slot:activator="{ on }">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mt-5 mr-2"
            v-on="on"
            absolute
            dark
            fab
            top
            right
            color="primary"
            @click="openForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar cliente</span>
      </v-tooltip>
      <!-- <v-btn color="primary" dark class="mb-2" @click="openForm()">Novo Cliente</v-btn> -->
    </template>
    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="resetDialog">close</v-icon>
      </v-system-bar>
      <v-card-title class="mb-0 pb-0">
        <span class="title grey--text text--darken-2">{{
          setTitleForm(formData.id)
        }}</span>
      </v-card-title>
      <v-card-text class="mt-0 pt-0">
        <v-tabs
          id="clientTabs"
          class="pt-3"
          v-model="active"
          color="white"
          slider-color="primary"
        >
          <v-tab>Dados do cliente</v-tab>
          <v-tab>Módulos disponíveis</v-tab>
          <v-tab>Tema e paleta de cores</v-tab>
          <v-tab>Configuração de alertas</v-tab>
          <v-tab-item>
            <v-form
              ref="clientUserForm"
              v-model="validForm"
              lazy-validation
              class="mt-0 pt-0"
            >
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex sm12 md6>
                    <v-text-field
                      v-model="formData.name"
                      label="Nome/ Razão social"
                      :rules="$store.state.formRules.required"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12 md6>
                    <v-text-field
                      v-model="formData.document"
                      label="CPF/CNPJ"
                      :mask="
                        formData.document.length <= 11
                          ? '###.###.###-########'
                          : '##.###.###/####-##'
                      "
                      :rules="$store.state.formRules.cpfCnpjRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex m6 md5>
                    <v-text-field
                      v-model="formData.accountable"
                      label="Nome do responsável"
                      :rules="$store.state.formRules.required"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm6 md4>
                    <v-text-field
                      v-model="formData.email"
                      label="E-mail"
                      :rules="$store.state.formRules.emailRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm6 md3>
                    <v-text-field
                      v-model="formData.phone"
                      label="Telefone"
                      :rules="$store.state.formRules.required"
                      :mask="
                        formData.phone.length < 11
                          ? '(##) ####-#####'
                          : '(##) #####-####'
                      "
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!-- <v-divider></v-divider> -->
                <AddressForm
                  :loadAddress="(data) => loadAddress(data)"
                  :forwShow="dialog"
                  :editedData="addressData"
                />
              </v-container>
            </v-form>
          </v-tab-item>
          <v-tab-item class="py-5">
            <!-- <h5 class="ml-2 mt-5 mb-4 text-xs-left subheading">Selecione os módulos</h5> -->
            <v-data-table :items="models" hide-actions hide-headers class>
              <template v-slot:items="props">
                <td class="text-xs-right">
                  <b>{{ props.item.label }}</b>
                </td>
                <td class="text-xs-left">
                  <v-switch
                    class="smallSwitch mt-0"
                    v-model="modelsOn"
                    :value="`${props.item.name}View`"
                    label="Apenas visualização"
                    color="primary"
                    hide-details
                    @change="updateSwitch(`${props.item.name}View`, modelsOn, props.item.name)"
                  ></v-switch>
                </td>
                <td class="text-xs-center">
                  <v-switch
                    class="smallSwitch mt-0"
                    v-model="modelsOn"
                    :value="`${props.item.name}On`"
                    label="Ativar funcionalidade"
                    color="primary"
                    hide-details
                    @change="updateSwitch(`${props.item.name}On`, modelsOn, props.item.name)"
                  ></v-switch>
                </td>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item>
            <v-layout wrap class="pt-4">
              <v-flex xs6 class="px-5">
                <v-layout wrap>
                  <ColorPickerClient
                    :editVal="getClientColor"
                    :autoClose="autoClose"
                    field="clientColor"
                    :updateColorField="updateColorField"
                    label="Selecione a cor principal do cliente"
                  />
                  <v-flex xs12 class="px-4 pt-4">
                    <h2 class="body-2 pl-2 text-xs-left pt-2">
                      <v-icon
                        v-if="formData.theme.bg"
                        @click="resetImageBg"
                        class="delImage mr-2"
                        >delete_forever</v-icon
                      >Background
                    </h2>
                    <div id="previewBg" class="imgBoxBg grey lighten-3">
                      <!-- <v-img v-if="uploadImg" :src="uploadImg" aspect-ratio="1.3"></v-img> -->
                      <img
                        :src="formData.theme.bg"
                        height="200"
                        v-if="formData.theme.bg"
                      />
                      <span v-if="!formData.theme.bg">1024 x 768</span>
                    </div>
                    <v-flex xs12>
                      <div style="position: relative">
                        <v-text-field
                          label="Selecione uma imagem"
                          @click="pickFileBg"
                          v-model="formData.theme.imageNameBg"
                          prepend-icon="attach_file"
                        ></v-text-field>
                        <input
                          id="bgIpt"
                          type="file"
                          style="display: none"
                          ref="imageBg"
                          accept="image/*"
                          @change="onFilePickedBg"
                        />
                      </div>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 class="px-5">
                <div class="px-4 pt-2">
                  <h2 class="body-2 pl-2 text-xs-left ml-1 pt-2">
                    <v-icon
                      v-if="formData.theme.avatar"
                      @click="resetImage"
                      class="delImage mr-2"
                      >delete_forever</v-icon
                    >Logotipo
                  </h2>
                  <div id="preview" class="imgBox grey lighten-3">
                    <v-img
                      v-if="formData.theme.avatar"
                      :src="formData.theme.avatar"
                      max-height="100px"
                      max-width="200px"
                      position="left center"
                      contain
                    ></v-img>
                    <!-- <img
                      :src="formData.theme.avatar"
                      height="100"
                      v-if="formData.theme.avatar"
                    /> -->
                    <span v-if="!formData.theme.avatar">200 x 100</span>
                  </div>
                  <v-flex xs12>
                    <div style="position: relative">
                      <v-text-field
                        label="Selecione uma imagem"
                        @click="pickFile"
                        v-model="formData.theme.imageName"
                        prepend-icon="attach_file"
                      ></v-text-field>
                      <input
                        id="logoIpt"
                        type="file"
                        style="display: none"
                        ref="image"
                        accept="image/*"
                        @change="onFilePicked"
                      />
                    </div>
                  </v-flex>
                </div>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tab-item>
            <v-layout wrap class="pt-4">
              <v-flex xs12 class="px-5 text-xs-left">
                <span class="title text-xs-left grey--text text--darken-2"
                  >Definir periodicidade de envio de alertas</span
                >
              </v-flex>
              <v-flex xs12 text-xs-left px-5>
                <div class="caption text-xs-left pb-3 mx-1 pt-1">
                  Você pode selecionar o período mensal, ou semanal. Quando
                  selecionado o período mensal o cliente cadastrado receberá as
                  notificações sempre no primeiro dia de cada mês. Selecionando
                  o período semanal o usuário será notificado em todos os dias
                  da semana que forem selecionados no calendário semanal.
                </div>
              </v-flex>
              <v-flex xs12 class="pa-3 pl-5 text-xs-left">
                <span class="title text-xs-left grey--text text--darken-2"
                  >Selecione um dos períodos</span
                >
              </v-flex>
              <v-flex xs12 class="px-5"
                ><v-switch
                  class="smallSwitch mt-0"
                  v-model="monthlySend"
                  label="Enviar alertas mensalmente"
                  color="primary"
                  hide-details
                >
                </v-switch
              ></v-flex>
              <v-flex xs12 class="px-5 mt-4"
                ><v-switch
                  class="smallSwitch mt-0"
                  v-model="weeklySend"
                  label="Enviar alertas semanalmente"
                  color="primary"
                  hide-details
                >
                </v-switch
              ></v-flex>
              <v-flex xs3 class="mt-2 pl-5"
                ><v-checkbox
                  v-model="notification_frequency"
                  value="monday"
                  label="2ª feira"
                  :disabled="chkStatus"
                ></v-checkbox
              ></v-flex>
              <v-flex xs3 class="mt-2 pl-4"
                ><v-checkbox
                  v-model="notification_frequency"
                  value="tuesday"
                  label="3ª feira"
                  :disabled="chkStatus"
                ></v-checkbox
              ></v-flex>
              <v-flex xs3 class="mt-2 pl-4"
                ><v-checkbox
                  v-model="notification_frequency"
                  value="wednesday"
                  label="4ª feira"
                  :disabled="chkStatus"
                ></v-checkbox
              ></v-flex>
              <v-flex xs3 class="mt-2 pl-4"
                ><v-checkbox
                  v-model="notification_frequency"
                  value="thursday"
                  label="5ª feira"
                  :disabled="chkStatus"
                ></v-checkbox
              ></v-flex>
              <v-flex xs3 class="mt-2 pl-5"
                ><v-checkbox
                  v-model="notification_frequency"
                  value="friday"
                  label="6ª feira"
                  :disabled="chkStatus"
                ></v-checkbox
              ></v-flex>
              <v-flex xs3 class="mt-2 pl-4"
                ><v-checkbox
                  v-model="notification_frequency"
                  value="saturday"
                  label="Sábado"
                  :disabled="chkStatus"
                ></v-checkbox
              ></v-flex>
              <v-flex xs3 class="mt-2 pl-4"
                ><v-checkbox
                  v-model="notification_frequency"
                  value="sunday"
                  label="Domingo"
                  :disabled="chkStatus"
                ></v-checkbox
              ></v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="resetDialog"
          >Cancelar</v-btn
        >
        <v-btn color="primary" flat @click="doSave">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ColorPickerClient from '../../components/ColorPicker'
import AddressForm from '../common/AddressForm'

const defaultForm = {
  modules_available: {
    users: 0,
    condominiums: 0,
    documents: 0,
    contracts: 0,
    reports: 0,
    profile: 0,
    thirds: 0,
    provision: 0,
    dashboard: 0,
    checklists: 0,
    financial: 0,
    standards: 0,
    datasheet: 0,
  },
  theme: {
    imageFile: '',
    imageFileBg: '',
    clientColor: '',
    imageName: '',
    avatar: '',
    imageNameBg: '',
    bg: ''
  },
  id: null,
  name: '',
  accountable: '',
  document: '',
  active: null,
  phone: '',
  password: '',
  email: '',
  updated_at: '',
  profile_id: '',
  address: {
    number_address: '',
    address_id: '',
    type: '',
    zipcode: '',
    address: '',
    district: '',
    state: '',
    city: '',
    complement: ''
  }
}

export default {
  name: 'clientsForm',

  components: {
    AddressForm,
    ColorPickerClient
  },

  props: {
    openForm: Function,
    closeForm: Function,
    saveClient: Function,
    dialog: Boolean,
    editFormData: Object
  },

  data () {
    return {
      weekArr: [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
      ],
      chkStatus: true,
      monthlySend: false,
      weeklySend: false,
      notification_frequency: [],
      modelsOn: [],
      autoClose: false,
      models: [
        {
          label: 'Checklists',
          justShow: false,
          modelOn: false,
          name: 'checklists'
        },
        {
          label: 'Condomínios',
          justShow: false,
          modelOn: false,
          name: 'condominiums'
        },
        {
          label: 'Contratos',
          justShow: false,
          modelOn: false,
          name: 'contracts'
        },
        {
          label: 'Documentação',
          justShow: false,
          modelOn: false,
          name: 'documents'
        },
        {
          label: 'Dashboard',
          justShow: false,
          modelOn: false,
          name: 'dashboard'
        },
        {
          label: 'Ficha Técnica',
          justShow: false,
          modelOn: false,
          name: 'datasheet'
        },
        {
          label: 'Financeiro',
          justShow: false,
          modelOn: false,
          name: 'financial'
        },
        {
          label: 'Padrões do Sistema',
          justShow: false,
          modelOn: false,
          name: 'standards'
        },
        {
          label: 'Perfis de Usuários',
          justShow: false,
          modelOn: false,
          name: 'profile'
        },
        {
          label: 'Prestação de Contas',
          justShow: false,
          modelOn: false,
          name: 'provision'
        },
        {
          label: 'Relatórios',
          justShow: false,
          modelOn: false,
          name: 'reports'
        },
        {
          label: 'Terceiros',
          justShow: false,
          modelOn: false,
          name: 'thirds'
        },
        {
          label: 'Usuários',
          justShow: false,
          modelOn: false,
          name: 'users'
        },
      ],
      active: 0,
      addressData: { ...defaultForm.address },
      formData: { ...defaultForm },
      validForm: true
    }
  },

  computed: {
    dialogShow () {
      return this.dialog
    },

    getClientColor () {
      return this.formData.theme ? this.formData.theme.clientColor : '#002857'
    }
  },

  watch: {
    monthlySend (v) {
      if (v) {
        this.notification_frequency = []
        this.weeklySend = false
        this.chkStatus = true
      }
    },

    weeklySend (v) {
      if (v) {
        this.monthlySend = false
        this.chkStatus = false
      } else {
        this.weeklySend = false
        this.chkStatus = true
        this.notification_frequency = []
      }
    },

    dialogShow (val) {
      if (val) {
        let _this = this
        this.autoClose = true
        const tabs = document.querySelectorAll('#clientTabs .v-tabs__item')
        tabs[1].click()
        tabs[0].click()
        this.formData = { ...defaultForm }

        if (this.$props.editFormData) {
          this.formData = { ...this.editFormData }
          this.formData.theme = defaultForm.theme
          // edição thema e modulos

          if (this.editFormData.id) {
            if (this.editFormData.notification_frequencys) {
              this.notification_frequency = [
                ...this.weekArr.filter((item) => {
                  if (this.editFormData.notification_frequencys[item] == 1) {
                    return item
                  }
                })
              ]

              this.weeklySend = this.notification_frequency.length > 0
              this.monthlySend = this.editFormData.notification_frequencys['monthly'] == 1
            }

            this.getModelsAndTheme(this.editFormData.id).then((data) => {
              data.modules_available_users
                ? (this.formData.modules_available = {
                  ...data.modules_available_users
                })
                : (this.formData.modules_available = {
                  ...defaultForm.modules_available
                })
              this.setSelectedModels()
              this.formData.theme = defaultForm.theme

              data.clienttheme_users.color
                ? (_this.formData.theme.clientColor =
                    data.clienttheme_users.color)
                : (_this.formData.theme.clientColor = '')

              setTimeout(() => {
                _this.formData.theme.clientColor = data.clienttheme_users.color
                _this.updateColorField(
                  data.clienttheme_users.color,
                  'clientColor'
                )
              }, 200)

              data.clienttheme_users.background
                ? (this.formData.theme.bg = data.clienttheme_users.background)
                : (this.formData.theme.bg = '')

              data.clienttheme_users.logo
                ? (this.formData.theme.avatar = data.clienttheme_users.logo)
                : (this.formData.theme.avatar = '')
            })
          }
          this.formData.theme = defaultForm.theme

          // edição thema e modulos

          this.addressData = { ...this.editFormData.address }
        }
      } else {
        this.resetImage()
        this.resetImageBg()
        this.monthlySend = true
        this.modelsOn = []
        this.autoClose = false
        this.$refs.clientUserForm.resetValidation()
        this.formData = { ...defaultForm }
        this.addressData = { ...defaultForm.address }
      }
    }
  },

  methods: {
    updateSwitch (name, array, value) {
      if (array.includes(name)) {
        if (name.includes('View')){
          if (array.includes(`${value}On`)) {
            const indexToRemove = array.indexOf(`${value}On`)

            this.modelsOn.splice(indexToRemove, 1)
          }
        } else {
           if (array.includes(`${value}View`)) {
            const indexToRemove = array.indexOf(`${value}View`)

            this.modelsOn.splice(indexToRemove, 1)
          }
        }
      }
    },

    setSelectedModels () {
      let obj = this.formData.modules_available
      
      Object.keys(obj).forEach((key) => {
        if (obj[key] > 0) {
          obj[key] == 2
            ? this.modelsOn.push(`${key}On`)
            : this.modelsOn.push(`${key}View`)
        }
      })
    },

    async getModelsAndTheme (id) {
      let resp
      let obj = {
        url: 'api/clienttheme_modules/' + id,
        query: '',
        method: 'get'
        // noLoader: true,
      }
      await this.$store.dispatch('request/doRequest', obj).then((response) => {
        resp = response.data
      })
      return resp
    },

    async setStatusModels () {
      this.formData.modules_available = { ...defaultForm.modules_available }

      await this.modelsOn.map((mod) => {
        if (mod == 'usersView' && this.formData.modules_available.users != 2) {
          this.formData.modules_available.users = 1
        }

        if (mod == 'usersOn') {
          this.formData.modules_available.users = 2
        }

        if (mod == 'condominiumsView' && this.formData.modules_available.condominiums != 2) {
          this.formData.modules_available.condominiums = 1
        }

        if (mod == 'condominiumsOn') {
          this.formData.modules_available.condominiums = 2
        }

        if (mod == 'condominiumsView' && this.formData.modules_available.condominiums != 2) {
          this.formData.modules_available.condominiums = 1
        }

        if (mod == 'condominiumsOn') {
          this.formData.modules_available.condominiums = 2
        }

        if (mod == 'documentsView' && this.formData.modules_available.documents != 2) {
          this.formData.modules_available.documents = 1
        }

        if (mod == 'documentsOn') {
          this.formData.modules_available.documents = 2
        }

        if (mod == 'contractsView' && this.formData.modules_available.contracts != 2) {
          this.formData.modules_available.contracts = 1
        }

        if (mod == 'contractsOn') {
          this.formData.modules_available.contracts = 2
        }

        if (mod == 'reportsView' && this.formData.modules_available.reports != 2) {
          this.formData.modules_available.reports = 1
        }

        if (mod == 'reportsOn') {
          this.formData.modules_available.reports = 2
        }

        if (mod == 'profileView' && this.formData.modules_available.profile != 2) {
          this.formData.modules_available.profile = 1
        }

        if (mod == 'profileOn') {
          this.formData.modules_available.profile = 2
        }

        if (mod == 'thirdsView' && this.formData.modules_available.thirds != 2) {
          this.formData.modules_available.thirds = 1
        }

        if (mod == 'thirdsOn') {
          this.formData.modules_available.thirds = 2
        }

        if (mod == 'provisionView' && this.formData.modules_available.provision != 2) {
          this.formData.modules_available.provision = 1
        }

        if (mod == 'provisionOn') {
          this.formData.modules_available.provision = 2
        }

        if (mod == 'dashboardView' && this.formData.modules_available.dashboard != 2) {
          this.formData.modules_available.dashboard = 1
        }

        if (mod == 'dashboardOn') {
          this.formData.modules_available.dashboard = 2
        }

        if (mod == 'checklistsView' && this.formData.modules_available.checklists != 2) {
          this.formData.modules_available.checklists = 1
        }

        if (mod == 'checklistsOn') {
          this.formData.modules_available.checklists = 2
        }

        if (mod == 'financialView' && this.formData.modules_available.financial != 2) {
          this.formData.modules_available.financial = 1
        }

        if (mod == 'financialOn') {
          this.formData.modules_available.financial = 2
        }

        if (mod == 'standardsView' && this.formData.modules_available.standards != 2) {
          this.formData.modules_available.standards = 1
        }

        if (mod == 'standardsOn') {
          this.formData.modules_available.standards = 2
        }

        if (mod == 'datasheetView' && this.formData.modules_available.datasheet != 2) {
          this.formData.modules_available.datasheet = 1
        }

        if (mod == 'datasheetOn') {
          this.formData.modules_available.datasheet = 2
        }
      })
    },

    resetImage () {
      document.getElementById('logoIpt').value = ''
      this.formData.theme.imageName = ''
      this.formData.theme.avatar = ''
      this.formData.theme.imageFile = ''
    },

    resetImageBg () {
      document.getElementById('bgIpt').value = ''
      this.formData.theme.imageNameBg = ''
      this.formData.theme.bg = ''
      this.formData.theme.imageFileBg = ''
    },

    pickFile () {
      this.$refs.image.click()
    },

    pickFileBg () {
      this.$refs.imageBg.click()
    },

    onFilePicked (e) {
      const files = e.target.files
      let _this = this
      console.log('getimage')
      if (files[0] !== undefined) {
        this.formData.theme.imageName = files[0].name
        if (this.formData.theme.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          _this.formData.theme.avatar = fr.result
          _this.formData.theme.imageFile = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.formData.theme.imageName = ''
        this.formData.theme.imageFile = ''
        this.formData.theme.avatar = ''
      }
    },

    onFilePickedBg (e) {
      const files = e.target.files

      if (files[0] !== undefined) {
        this.formData.theme.imageNameBg = files[0].name
        if (this.formData.theme.imageNameBg.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.formData.theme.bg = fr.result
          this.formData.theme.imageFileBg = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.formData.theme.imageNameBg = ''
        this.formData.theme.imageFileBg = ''
        this.formData.theme.bg = ''
      }
    },

    updateColorField (val, field) {
      this.formData.theme[field] = val
    },

    setTitleForm (id) {
      let returnTitle
      if (id) {
        returnTitle = 'Editar cliente'
      } else {
        returnTitle = 'Novo cliente'
      }
      if (this.viewForm) {
        returnTitle = 'Visualização'
      }
      return returnTitle
    },

    loadAddress (data) {
      let obj = {
        district: data.bairro,
        zipcode: data.cep,
        city: data.localidade,
        address: data.logradouro,
        state: data.uf
      }
      this.addressData = { ...obj }
    },

    resetDialog () {
      this.$props.closeForm()
    },

    doSave () {
      if (!this.$refs.clientUserForm.validate()) {
        return
      }
      this.setStatusModels().then((_) => {
        if (this.weeklySend) {
          if (!this.notification_frequency.length) {
            let opts = {
              message: `Selecione ao menos 1 dia da semana`,
              type: 'warning'
            }
            this.$store.commit('showAlert', opts)
            return
          }
          this.formData.notification_frequency = this.notification_frequency
        } else if (this.monthlySend) {
          this.formData.notification_frequency = ['monthly']
        }

        if (!this.formData.notification_frequencys) {
          this.formData.notification_frequencys = {
            'user_id': this.formData.id
          }
        }

        var array = Array.from(this.weekArr)
        array.push('monthly')

        for (let item of array) {
          if (this.formData.notification_frequency) {
            this.formData.notification_frequencys[item] = this.formData.notification_frequency.includes(item) ? 1 : 0
          } else {
            this.formData.notification_frequencys[item] = 0
          }
        }

        this.formData.address = this.addressData
        const callback = function () {
          this.$props.closeForm()
        }
        console.log('datas', this.formData)
        this.$props.saveClient(this.formData, callback)
      })
    }
  }
}
</script>

<style>
.imgBox {
  overflow: hidden;
  display: flex;
  width: 200px;
  height: 100px;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
}
.imgBoxBg {
  overflow: hidden;
  display: flex;
  width: 280px;
  height: 200px;
  align-items: center;
  justify-content: center;
  margin: auto;
}
</style>
